import type { IconComponentProps } from '@gto/icons-react/icon'
import { SuitSpadeIcon } from '@gto/icons-react/solid/suit-spade'

/**
 * The solid spade in the 12 by 16 box of the suit file that the icon replaced. The suit of the
 * icon library has a margin on the 24 grid; this view box removes it, so the suit fills the
 * height of its box. For a map from a suit to its icon, which cannot give the view box.
 */
export const SpadeSolidIcon = (props: IconComponentProps) => (
  <SuitSpadeIcon
    viewBox="1.911 -0.248 19.596 26.128"
    {...props}
  />
)
